import { EventSystem } from "./EventSystem";
import { showToast } from "./Utils";
import { ILocation } from "./models/ILocation";

/**
 * Geo location tracking.  This counts calls to start() and stop() and will only
 * monitor location when it needs to.
 */
export class GeoLocation {
    private _watchId: number | undefined;

    constructor(private readonly _events: EventSystem) {}

    private _useCount = 0;

    public start() {
        this._useCount++;
        this._update(true);
    }

    public stop() {
        this._useCount--;
        this._update(this._useCount !== 0);
    }

    private _update(shouldBeRunning: boolean) {
        if (this._watchId && !shouldBeRunning) {
            navigator.geolocation.clearWatch(this._watchId);
            this._watchId = undefined;
            this._events.raiseEvent("ds-location-tracking-stopped");
        } else if (!this._watchId && shouldBeRunning) {
            this._events.raiseEvent("ds-location-tracking-started");
            this._watchId = navigator.geolocation.watchPosition(
                (position: GeolocationPosition) => {
                    const { latitude, longitude } = position.coords;
                    const location = {
                        lat: latitude,
                        lon: longitude,
                    } as ILocation;
                    this._events.raiseEvent("ds-location-changed", location);
                },
                () => {
                    showToast("Could not get location", "warning");
                },
                {
                    enableHighAccuracy: true,
                }
            );
        }
    }
}
